// src/components/Chat/PhoneNumberModal.js
import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography} from '@mui/material';

const PhoneNumberModal = ({ open, onClose, onConfirm, label}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (validatePhoneNumber(phoneNumber)) {
      onConfirm(phoneNumber);
    } else {
        setError('Wprowadź poprawny numer telefonu (9 cyfr).');
    }
  };

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{9}$/;
    return phoneRegex.test(number);
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="phone-number-dialog" BackdropProps={{style: { backgroundColor: 'transparent' }}}>
      <DialogTitle id="phone-number-dialog">{label}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="phone-number"
          label="Numer telefonu"
          type="tel"
          fullWidth
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <Typography color='red'>{error}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Anuluj
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Potwierdź
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhoneNumberModal;
